import React, { useState, useContext, useEffect } from 'react';

//router
import { NavLink as RDNavLink } from 'react-router-dom';

//images
import LogoIMG from '../css/images/logo-mazda.svg';
import closeImg from '../css/images/exit.svg';

//service
import * as mainApi from 'api/mainApi';

//context
import { UserContext } from 'context/UserContext';

const Navigation = () => {
	const { userData } = useContext(UserContext);
	const [isOpen, setIsOpen] = useState(false);
	const [scrolled, setScrolled] = useState(false);

	const close = () => setIsOpen(false);

	useEffect(() => {
		const handleScroll = () => setScrolled(window.scrollY > 10);
		window.addEventListener('scroll', handleScroll, { passive: true });
		return () => window.removeEventListener('scroll', handleScroll);
	}, []);

	const handleLogout = async () => {
		close();
		const data = await mainApi.userLogout();
		if (data.succeded) {
			window.dispatchEvent(new Event('logoutUser'));
		}
	};

	return (
		<div className="main-header">
			<nav className={`navbar bg-main-bar navbar-expand-lg${scrolled ? ' scrolled' : ''}`}>
				<div className="container">
					<RDNavLink
						to="/"
						className="navbar-brand sms-logo"
						aria-label="Inicio Mazda"
						onClick={(e) => {
							e.preventDefault();
							close();
							if (window.location.pathname === '/') {
								window.location.reload();
							} else {
								window.location.assign('/');
							}
						}}
					>
						<div className="logo">
							<img
								src={LogoIMG}
								alt="Mazda Accessories Challenge"
								className="logo__img"
							/>
						</div>
					</RDNavLink>

					<button
						className="navbar-toggler"
						type="button"
						onClick={() => setIsOpen((prev) => !prev)}
						aria-expanded={isOpen}
						aria-label="Toggle navigation"
					>
						<span className="navbar-toggler-icon" />
					</button>

					<div className={`main-navbar__collapse${isOpen ? ' is-open' : ''}`}>
						<ul className="navbar-nav main-links">
							<li className="nav-item">
								<RDNavLink className="nav-link am-link" to="/" onClick={close}>
									Catálogo
								</RDNavLink>
							</li>
							<li className="nav-item">
								<RDNavLink
									className="nav-link am-link"
									to="mazda-cx5"
									onClick={close}
								>
									Mazda CX-5
								</RDNavLink>
							</li>
							<li className="nav-item">
								<RDNavLink
									className="nav-link am-link"
									to="bases-legales"
									onClick={close}
								>
									Acerca de Mazda Accessories Challenge
								</RDNavLink>
							</li>
							<li className="nav-item">
								<div className="points-pill">
									{userData.points?.toLocaleString('es-ES') || 0} PUNTOS
								</div>
							</li>
							<li className="nav-item">
								<button
									className="nav-link exit"
									onClick={handleLogout}
									aria-label="Cerrar sesión"
								>
									<img
										src={closeImg}
										alt="Cerrar sesión"
										className="logout-icon"
									/>
								</button>
							</li>
						</ul>
					</div>
				</div>
			</nav>
		</div>
	);
};

export default Navigation;
